import {
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormLabel,
  Stack,
  TextField
} from '@mui/material';
import { PromptInputs } from './CreatePromptDialog';
import { FieldArrayWithId, FieldErrors, UseFormRegister } from 'react-hook-form';
import LoadingDots from '../../Animated/Icons/LoadingDots';

interface PromptDialogFormProps {
  register: UseFormRegister<PromptInputs>;
  fields: FieldArrayWithId<PromptInputs, 'gamePacks'>[];
  errors: FieldErrors<PromptInputs>;
  onCancel: () => void;
  onSubmit: () => void;
  isLoading?: boolean;
  isSubmitting?: boolean;
}

export const PromptDialogForm = ({
  register,
  fields,
  errors,
  onCancel,
  onSubmit,
  isLoading,
  isSubmitting
}: PromptDialogFormProps) => {
  return (
    <>
      <DialogTitle className="text-[16px] pt-[8px] mb-[8px]">
        Note: Use an underscore (_) for fill-in space in prompts.
      </DialogTitle>
      <DialogContent>
        <form onSubmit={onSubmit}>
          <FormLabel className="text-black font-bold">Prompt</FormLabel>
          <TextField
            disabled={isLoading}
            className="mb-[16px]"
            margin="dense"
            id="0"
            type="text"
            fullWidth
            autoFocus
            variant="standard"
            error={!!errors.prompt}
            helperText={errors.prompt?.message}
            placeholder="e.g. “_ gives me peace of mind”"
            {...register('prompt', {
              required: 'Prompt is required',
              pattern: {
                value: /^[^@#$%^&*{}|<>]*$/,
                message: 'Special characters are not allowed (@#$%^&*{}|<>)'
              },
              minLength: 10,
              maxLength: 100
            })}
          />
          <FormLabel className="text-black font-bold">Select Game Packs to add to</FormLabel>
          <Stack>
            {fields.map((field, index) => {
              return (
                <FormControlLabel
                  key={`org-checkbox-${field.id}`}
                  control={
                    <Checkbox
                      defaultChecked={field.selected}
                      sx={{
                        color: '#D3D3D3',
                        '&.Mui-checked': {
                          color: '#F58C29'
                        }
                      }}
                      {...register(`gamePacks.${index}.selected`)}
                    />
                  }
                  label={field.name}
                />
              );
            })}
          </Stack>
          {isLoading && <LoadingDots />}
        </form>
      </DialogContent>
      <DialogActions>
        <button className="btn btn-neutral secondary mr-[5px]" onClick={onCancel}>
          Cancel
        </button>
        <button className="btn btn-primary" onClick={onSubmit} disabled={isSubmitting}>
          Save
        </button>
      </DialogActions>
    </>
  );
};
